import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "../firebase";

// Logo lives at a stable path so a replace overwrites the old file. The download
// URL is stored on config/shop. Validation (type, size) happens in the caller.
const LOGO_PATH = "branding/logo";

export const MAX_LOGO_BYTES = 2 * 1024 * 1024; // 2 MB
// Raster only. SVG is intentionally excluded: an SVG can carry scripts and, when
// served from the storage download URL and opened directly, becomes an XSS
// vector. Restricting to raster formats removes that class of risk.
export const ALLOWED_LOGO_TYPES = ["image/png", "image/jpeg", "image/webp"];

export async function uploadLogo(file: File): Promise<string> {
  const objectRef = ref(storage, LOGO_PATH);
  await uploadBytes(objectRef, file, { contentType: file.type });
  return getDownloadURL(objectRef);
}

export async function removeLogo(): Promise<void> {
  try {
    await deleteObject(ref(storage, LOGO_PATH));
  } catch (e) {
    // A missing object is fine; we only care that it is gone.
    console.warn("Logo delete skipped:", e);
  }
}
